import React, { useContext } from 'react';
import { Typography } from 'antd';
import { ApplicationUIContext } from '../Provider/Provider';

const { Title } = Typography;

export const CardTitle = ({ children }) => {
  const { isMobile } = useContext(ApplicationUIContext);

  return (
    <Title level={isMobile ? 3 : 4} style={{ margin: 0 }}>
      {children}
    </Title>
  );
};
